import type { SinglePagePdf } from "../../files/cached/SinglePagePdf"
import type { TaskBase } from "../base/TaskBase"
import type { TaskName } from "../TaskName"

export type TaskRasterizeOptions = {
  readonly enum: TaskName.TASK_RASTERIZE
  readonly source: SinglePagePdf
} & TaskBase
